"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewState = exports.DismissedViewState = exports.DeepViewState = exports.ResponseViewState = exports.InitialViewState = exports.InitialTranscendViewState = exports.IABViewState = void 0;
// main
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Consent Manager view state for the Interactive Advertising Bureau
 */
exports.IABViewState = (0, type_utils_1.makeEnum)({
    /** Transparency and Consent Framework for Europe */
    TCF_EU: 'TCF_EU',
});
/**
 * View States for Transcend's Consent Manager UI
 */
exports.InitialTranscendViewState = (0, type_utils_1.makeEnum)({
    /** expanded and showing quick select options */
    QuickOptions: 'QuickOptions',
    /** three option UI: essential, functional/analytics, advertising */
    QuickOptions3: 'QuickOptions3',
    /** accept all button call to action, with more options in the banner footer */
    AcceptAll: 'AcceptAll',
    /** toggle button that toggles on or off all active purposes in the current regime */
    AcceptAllRejectAllToggle: 'AcceptAllRejectAllToggle',
    /** accept all or more options, both as calls to action */
    AcceptAllOrMoreChoices: 'AcceptAllOrMoreChoices',
    /** accept all or reject all */
    AcceptOrRejectAll: 'AcceptOrRejectAll',
    /** accept all or reject all or more options */
    AcceptOrRejectAllOrMoreChoices: 'AcceptOrRejectAllOrMoreChoices',
    /** accept or reject the Analytics script tag */
    AcceptOrRejectAnalytics: 'AcceptOrRejectAnalytics',
    /** accept or reject the Advertising script tag */
    AcceptOrRejectAdvertising: 'AcceptOrRejectAdvertising',
    /** data collection notice with do not sell */
    NoticeAndDoNotSell: 'NoticeAndDoNotSell',
    /** open a modal that allows for an explanation of do not sell/share, before opting out */
    DoNotSellExplainer: 'DoNotSellExplainer',
    /** open a modal that allows for complete options toggling */
    CompleteOptionsToggles: 'CompleteOptionsToggles',
    /** open a modal that shows a notice that the privacy policy has changed, without any prompt to change consent */
    PrivacyPolicyNotice: 'PrivacyPolicyNotice',
    /**
     * open a modal that shows a notice that the privacy policy has changed, without any prompt to change consent
     * and no button to close the modal. instead there is an X in the top right corner of the modal
     */
    PrivacyPolicyNoticeWithCloseButton: 'PrivacyPolicyNoticeWithCloseButton',
    /** expanded and showing full checkbox options */
    CompleteOptions: 'CompleteOptions',
    /** complete options, but selecting a checkbox means the user is opted out */
    CompleteOptionsInverted: 'CompleteOptionsInverted',
    /** hidden */
    Hidden: 'Hidden',
});
/**
 * Consent Manager view states that can be used at launch
 */
exports.InitialViewState = (0, type_utils_1.makeEnum)({
    /** View States for Transcend's Consent Manager UI */
    ...exports.InitialTranscendViewState,
    /** View States for IAB Frameworks */
    ...exports.IABViewState,
});
/**
 * View states that are displayed in response to a user request (e.g. transcend.doNotSell() or )
 */
exports.ResponseViewState = (0, type_utils_1.makeEnum)({
    /** notice that do not sell has been acknowledged properly */
    DoNotSellDisclosure: 'DoNotSellDisclosure',
    /** notice of a 1 click opt out for multiple consent purposes */
    OptOutDisclosure: 'OptOutDisclosure',
});
/**
 * Consent Manager view states that can be navigated to after initial view state
 */
exports.DeepViewState = (0, type_utils_1.makeEnum)({
    /** language options */
    LanguageOptions: 'LanguageOptions',
});
/**
 * Consent Manager view states after it's been dismissed
 */
exports.DismissedViewState = (0, type_utils_1.makeEnum)({
    /** showing and collapsed */
    Collapsed: 'Collapsed',
    /** closed */
    Closed: 'Closed',
});
/**
 * All possible view states of the Consent Manager
 */
exports.ViewState = (0, type_utils_1.makeEnum)({
    ...exports.InitialViewState,
    ...exports.ResponseViewState,
    ...exports.DeepViewState,
    ...exports.DismissedViewState,
});
//# sourceMappingURL=viewState.js.map